var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useContext } from 'react';
import { useForm } from 'react-final-form';
import { isEqual, omit } from 'lodash';
import { isFalsy } from '../../../../utils/common';
import { isOptionType } from '../../inputs/DropDown';
import { getFilterOptions, getSortedUniversityFilters, roundDownToNextNearestThousand, roundUpToNextNearestThousand } from '../utils';
import { eligibilitySchema } from './schema/eligibility.schema';
import { CfEligibilityUtil } from './CFEligibilityUtil';
import { CFFilterContext } from './CFFilterProvider';
var useCFFilters = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
    var form = useForm();
    var _6 = useContext(CFFilterContext), applyFilter = _6.applyFilter, sharedList = _6.sharedList, setInitialEligiblityValues = _6.setInitialEligiblityValues;
    var degreeValues = (_b = (_a = form.getState()) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.degreeIdsV2;
    var cityValues = (_d = (_c = form.getState()) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.cityIds;
    var stateValues = (_f = (_e = form.getState()) === null || _e === void 0 ? void 0 : _e.values) === null || _f === void 0 ? void 0 : _f.stateId;
    var intakeValues = (_h = (_g = form.getState()) === null || _g === void 0 ? void 0 : _g.values) === null || _h === void 0 ? void 0 : _h.intake;
    var courseDurationValues = (_l = (_k = (_j = form.getState()) === null || _j === void 0 ? void 0 : _j.values) === null || _k === void 0 ? void 0 : _k.courseDuration) !== null && _l !== void 0 ? _l : [0, 60];
    var highOfferInstituteValue = (_o = (_m = form.getState()) === null || _m === void 0 ? void 0 : _m.values) === null || _o === void 0 ? void 0 : _o.showOnlyPreferredInstitutes;
    var showOpenOnlyCourses = (_q = (_p = form.getState()) === null || _p === void 0 ? void 0 : _p.values) === null || _q === void 0 ? void 0 : _q.intakeStatus;
    var countryValues = isFalsy((_s = (_r = form.getState()) === null || _r === void 0 ? void 0 : _r.values) === null || _s === void 0 ? void 0 : _s.countryIds) ? null : (_u = (_t = form.getState()) === null || _t === void 0 ? void 0 : _t.values) === null || _u === void 0 ? void 0 : _u.countryIds;
    var studentNationality = (_w = (_v = form.getState()) === null || _v === void 0 ? void 0 : _v.values) === null || _w === void 0 ? void 0 : _w.sourceCountryId;
    var studentCurrencyValue = null;
    form.subscribe(function (_a) {
        var values = _a.values;
        studentCurrencyValue = values === null || values === void 0 ? void 0 : values.studentCurrency;
    }, { values: true });
    var convertedTuitionFeesMin = roundDownToNextNearestThousand(((_y = (_x = form === null || form === void 0 ? void 0 : form.getState()) === null || _x === void 0 ? void 0 : _x.values) === null || _y === void 0 ? void 0 : _y.minCourseFeeInInr) / (studentCurrencyValue === null || studentCurrencyValue === void 0 ? void 0 : studentCurrencyValue.conversionRate));
    var convertedTuitionFeesMax = roundUpToNextNearestThousand(((_0 = (_z = form === null || form === void 0 ? void 0 : form.getState()) === null || _z === void 0 ? void 0 : _z.values) === null || _0 === void 0 ? void 0 : _0.maxCourseFeeInInr) / (studentCurrencyValue === null || studentCurrencyValue === void 0 ? void 0 : studentCurrencyValue.conversionRate));
    var minTuitionFees = Number.isNaN(convertedTuitionFeesMin) ? 0 : convertedTuitionFeesMin;
    var maxtTuitionFees = (Number === null || Number === void 0 ? void 0 : Number.isNaN(convertedTuitionFeesMax)) ? 0 : convertedTuitionFeesMax;
    var tuitionFeesValues = {
        min: minTuitionFees,
        max: maxtTuitionFees,
        value: (_3 = (_2 = (_1 = form === null || form === void 0 ? void 0 : form.getState()) === null || _1 === void 0 ? void 0 : _1.values) === null || _2 === void 0 ? void 0 : _2.tuitionFees) !== null && _3 !== void 0 ? _3 : [minTuitionFees, maxtTuitionFees]
    };
    var universitiesValues = (_5 = (_4 = form.getState()) === null || _4 === void 0 ? void 0 : _4.values) === null || _5 === void 0 ? void 0 : _5.collegeIds;
    var updateFormForFilters = function (_a) {
        var name = _a.name, value = _a.value, prevValue = _a.prevValue, _b = _a.resetTags, resetTags = _b === void 0 ? true : _b;
        return __awaiter(void 0, void 0, void 0, function () {
            var currentCountryValues, countryLabelValuesWithoutEuropeCountryGroup, prevDestinationValue, values, destination;
            var _c, _d, _e, _f, _g, _h;
            return __generator(this, function (_j) {
                if (name)
                    form.change(name, value);
                // popular intakes for countries
                if (name === 'countryIds') {
                    currentCountryValues = value !== null && value !== void 0 ? value : [];
                    countryLabelValuesWithoutEuropeCountryGroup = (_c = currentCountryValues === null || currentCountryValues === void 0 ? void 0 : currentCountryValues.filter) === null || _c === void 0 ? void 0 : _c.call(currentCountryValues, function (currentCountry) { var _a, _b, _c; return ((_c = (_b = (_a = currentCountry === null || currentCountry === void 0 ? void 0 : currentCountry.value) === null || _a === void 0 ? void 0 : _a.split) === null || _b === void 0 ? void 0 : _b.call(_a, '-')) === null || _c === void 0 ? void 0 : _c[0]) === 'country'; });
                    (_d = props === null || props === void 0 ? void 0 : props.degreeIntakeInstance) === null || _d === void 0 ? void 0 : _d.fetchAndSetMapping({
                        entities: countryLabelValuesWithoutEuropeCountryGroup === null || countryLabelValuesWithoutEuropeCountryGroup === void 0 ? void 0 : countryLabelValuesWithoutEuropeCountryGroup.map(function (country) {
                            var _a, _b, _c, _d;
                            return {
                                entityId: Number((_b = (_a = country === null || country === void 0 ? void 0 : country.value) === null || _a === void 0 ? void 0 : _a.split('-')) === null || _b === void 0 ? void 0 : _b[1]),
                                entityType: ((_d = (_c = country === null || country === void 0 ? void 0 : country.value) === null || _c === void 0 ? void 0 : _c.split('-')) === null || _d === void 0 ? void 0 : _d[0]) === 'country' ? 'Country' : 'Country Group'
                            };
                        })
                    });
                }
                if (name === 'sourceCountryId') {
                    if (isOptionType(value) && typeof (value === null || value === void 0 ? void 0 : value.value) === 'number') {
                        (_e = props === null || props === void 0 ? void 0 : props.setSelectedSourceCountryId) === null || _e === void 0 ? void 0 : _e.call(props, value === null || value === void 0 ? void 0 : value.value);
                    }
                    // clearFilters({ preventStudyWhat: true, preventNationalityClear: true });
                }
                if (resetTags && name === 'tags') {
                    form.batch(function () {
                        form.change('tagsRawSearch', undefined);
                        form.change('transformedTags', undefined);
                    });
                }
                if (['stateId', 'collegeIds', 'cityIds'].includes(name) &&
                    Array.isArray(value) &&
                    value.length === 0) {
                    prevDestinationValue = (_f = (prevValue !== null && prevValue !== void 0 ? prevValue : [])) === null || _f === void 0 ? void 0 : _f.find(function (op) { return (op === null || op === void 0 ? void 0 : op.value) === destination; });
                    if (prevDestinationValue) {
                        form.batch(function () {
                            form.change('destination', undefined);
                            form.change('destinationCity', undefined);
                            form.change('destinationCountry', undefined);
                            form.change('destinationInstitute', undefined);
                            form.change('destinationState', undefined);
                        });
                    }
                }
                values = (_g = form.getState()) === null || _g === void 0 ? void 0 : _g.values;
                destination = (_h = values === null || values === void 0 ? void 0 : values.destination) === null || _h === void 0 ? void 0 : _h.value;
                // when showOnlyPreferredInstitutes is clicked remove all colleges, state and city
                if (name === 'showOnlyPreferredInstitutes' && (value === null || value === void 0 ? void 0 : value.value) === true) {
                    values === null || values === void 0 ? true : delete values.collegeIds;
                    values === null || values === void 0 ? true : delete values.stateId;
                    values === null || values === void 0 ? true : delete values.cityIds;
                    form.batch(function () {
                        form.change('collegeIds', undefined);
                        form.change('stateId', undefined);
                        form.change('cityIds', undefined);
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    var handleFilterApply = function (_a) {
        var name = _a.name, value = _a.value, _b = _a.forceApply, forceApply = _b === void 0 ? false : _b, prevValue = _a.prevValue, _c = _a.resetTags, resetTags = _c === void 0 ? true : _c, filters = _a.filters;
        return __awaiter(void 0, void 0, void 0, function () {
            var values, europeanCountryValues, wasEuropeCountryGroupSelected, anyEuropeanCountrySelectedNow, wasEuropeCountryGroupSelectedAndanyEuropeanCountrySelectedNow, countryValuesWithoutCountryGroup;
            var _d, _e, _f, _g, _h, _j, _k, _l;
            return __generator(this, function (_m) {
                if (name && isEqual(value, (_e = (_d = form === null || form === void 0 ? void 0 : form.getState()) === null || _d === void 0 ? void 0 : _d.initialValues) === null || _e === void 0 ? void 0 : _e[name])) {
                    return [2 /*return*/];
                }
                if (!isFalsy(filters)) {
                    filters === null || filters === void 0 ? void 0 : filters.forEach(function (filter) {
                        updateFormForFilters({
                            name: filter === null || filter === void 0 ? void 0 : filter.name,
                            value: filter === null || filter === void 0 ? void 0 : filter.value,
                            prevValue: filter === null || filter === void 0 ? void 0 : filter.preValue,
                            resetTags: filter === null || filter === void 0 ? void 0 : filter.resetTags
                        });
                    });
                }
                else {
                    updateFormForFilters({
                        name: name,
                        value: value,
                        prevValue: prevValue,
                        resetTags: resetTags
                    });
                }
                values = (_f = form.getState()) === null || _f === void 0 ? void 0 : _f.values;
                europeanCountryValues = (_h = ((_g = sharedList === null || sharedList === void 0 ? void 0 : sharedList.europeanCountries) !== null && _g !== void 0 ? _g : [])) === null || _h === void 0 ? void 0 : _h.map(function (europeanCountry) { return "country-".concat(Number(europeanCountry === null || europeanCountry === void 0 ? void 0 : europeanCountry.labelKey)); });
                wasEuropeCountryGroupSelected = !isFalsy((_j = prevValue === null || prevValue === void 0 ? void 0 : prevValue.find) === null || _j === void 0 ? void 0 : _j.call(prevValue, function (item) { return (item === null || item === void 0 ? void 0 : item.value) === 'countryGroup-7'; }));
                anyEuropeanCountrySelectedNow = (_k = values === null || values === void 0 ? void 0 : values.countryIds) === null || _k === void 0 ? void 0 : _k.some(function (country) {
                    return europeanCountryValues === null || europeanCountryValues === void 0 ? void 0 : europeanCountryValues.includes(country === null || country === void 0 ? void 0 : country.value);
                });
                wasEuropeCountryGroupSelectedAndanyEuropeanCountrySelectedNow = wasEuropeCountryGroupSelected && anyEuropeanCountrySelectedNow;
                countryValuesWithoutCountryGroup = (_l = values === null || values === void 0 ? void 0 : values.countryIds) === null || _l === void 0 ? void 0 : _l.filter(function (item) { return item.value !== 'countryGroup-7'; });
                if (wasEuropeCountryGroupSelectedAndanyEuropeanCountrySelectedNow) {
                    form.batch(function () {
                        // to removed from global search banner state
                        form.change('destination', undefined);
                        form.change('studyWhereTag', undefined);
                        form.change('studyWhereTagId', undefined);
                        // to removed from global search banner state
                        form.change('countryIds', countryValuesWithoutCountryGroup);
                        form.change('countryGroupIds', []);
                    });
                }
                // console.log({
                //   name,
                //   value,
                //   forceApply,
                //   prevValue,
                //   europeanCountryValues,
                //   wasEuropeCountryGroupSelected,
                //   anyEuropeanCountrySelectedNow,
                //   wasEuropeCountryGroupSelectedAndanyEuropeanCountrySelectedNow
                // });
                // console.log('values applied', {
                //   ...values,
                //   ...(wasEuropeCountryGroupSelectedAndanyEuropeanCountrySelectedNow && {
                //     countryIds: countryValuesWithoutCountryGroup,
                //     countryGroupIds: [],
                //     destination: null,
                //     studyWhereTag: null,
                //     studyWhereTagId: null
                //   })
                // });
                try {
                    if (forceApply || !form.getState().pristine) {
                        setTimeout(function () {
                            applyFilter === null || applyFilter === void 0 ? void 0 : applyFilter({
                                values: __assign(__assign({}, values), (wasEuropeCountryGroupSelectedAndanyEuropeanCountrySelectedNow && {
                                    countryIds: countryValuesWithoutCountryGroup,
                                    countryGroupIds: [],
                                    destination: null,
                                    studyWhereTag: null,
                                    studyWhereTagId: null
                                })),
                                scrollToTop: true,
                                source: 'RESULT_SECTION'
                            });
                        }, 0);
                    }
                    // Events
                    // triggerSideBarEvents(name, value);
                }
                catch (error) {
                    console.log(error);
                }
                return [2 /*return*/];
            });
        });
    };
    var getDegreeOptions = function (degreeAgreegationData) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var degreeIdsV2 = (_d = ((_c = (_b = (_a = form.getState()) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.degreeIdsV2) !== null && _c !== void 0 ? _c : [])) === null || _d === void 0 ? void 0 : _d.map(function (op) { return op === null || op === void 0 ? void 0 : op.value; });
        return getFilterOptions(__spreadArray(__spreadArray([], __read((_f = ((_e = degreeAgreegationData === null || degreeAgreegationData === void 0 ? void 0 : degreeAgreegationData.options) !== null && _e !== void 0 ? _e : [])) === null || _f === void 0 ? void 0 : _f.filter(function (op) { return degreeIdsV2 === null || degreeIdsV2 === void 0 ? void 0 : degreeIdsV2.includes(op === null || op === void 0 ? void 0 : op.id); })), false), __read((_h = ((_g = degreeAgreegationData === null || degreeAgreegationData === void 0 ? void 0 : degreeAgreegationData.options) !== null && _g !== void 0 ? _g : [])) === null || _h === void 0 ? void 0 : _h.filter(function (op) { return !(degreeIdsV2 === null || degreeIdsV2 === void 0 ? void 0 : degreeIdsV2.includes(op === null || op === void 0 ? void 0 : op.id)); })), false));
    };
    var getIntakeOptions = function (intakeAgreegationData, popularIntakes) {
        var _a, _b;
        var intakeOptions = [];
        try {
            intakeOptions = (_b = ((_a = intakeAgreegationData === null || intakeAgreegationData === void 0 ? void 0 : intakeAgreegationData.options) !== null && _a !== void 0 ? _a : [])) === null || _b === void 0 ? void 0 : _b.map(function (item) {
                var _a;
                var optionType = {
                    label: item.title,
                    value: JSON.stringify(item === null || item === void 0 ? void 0 : item.tags),
                    count: item === null || item === void 0 ? void 0 : item.count,
                    isPopular: (_a = (popularIntakes !== null && popularIntakes !== void 0 ? popularIntakes : [])) === null || _a === void 0 ? void 0 : _a.includes(JSON.stringify(item === null || item === void 0 ? void 0 : item.tags))
                };
                return optionType;
            });
        }
        catch (err) {
            console.error('error in stringifying data', err);
            intakeOptions = [];
        }
        return intakeOptions;
    };
    var getCityOptions = function (cityAgreegationData) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var cityIds = (_d = ((_c = (_b = (_a = form.getState()) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.cityIds) !== null && _c !== void 0 ? _c : [])) === null || _d === void 0 ? void 0 : _d.map(function (op) { return op === null || op === void 0 ? void 0 : op.value; });
        return getFilterOptions(__spreadArray(__spreadArray([], __read((_f = ((_e = cityAgreegationData === null || cityAgreegationData === void 0 ? void 0 : cityAgreegationData.options) !== null && _e !== void 0 ? _e : [])) === null || _f === void 0 ? void 0 : _f.filter(function (op) { return cityIds === null || cityIds === void 0 ? void 0 : cityIds.includes(op === null || op === void 0 ? void 0 : op.id); })), false), __read((_h = ((_g = cityAgreegationData === null || cityAgreegationData === void 0 ? void 0 : cityAgreegationData.options) !== null && _g !== void 0 ? _g : [])) === null || _h === void 0 ? void 0 : _h.filter(function (op) { return !(cityIds === null || cityIds === void 0 ? void 0 : cityIds.includes(op === null || op === void 0 ? void 0 : op.id)); })), false));
    };
    var getStateOptions = function (stateAgreegationData) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var cityIds = (_d = ((_c = (_b = (_a = form.getState()) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.stateId) !== null && _c !== void 0 ? _c : [])) === null || _d === void 0 ? void 0 : _d.map(function (op) { return op === null || op === void 0 ? void 0 : op.value; });
        return getFilterOptions(__spreadArray(__spreadArray([], __read((_f = ((_e = stateAgreegationData === null || stateAgreegationData === void 0 ? void 0 : stateAgreegationData.options) !== null && _e !== void 0 ? _e : [])) === null || _f === void 0 ? void 0 : _f.filter(function (op) { return cityIds === null || cityIds === void 0 ? void 0 : cityIds.includes(op === null || op === void 0 ? void 0 : op.id); })), false), __read((_h = ((_g = stateAgreegationData === null || stateAgreegationData === void 0 ? void 0 : stateAgreegationData.options) !== null && _g !== void 0 ? _g : [])) === null || _h === void 0 ? void 0 : _h.filter(function (op) { return !(cityIds === null || cityIds === void 0 ? void 0 : cityIds.includes(op === null || op === void 0 ? void 0 : op.id)); })), false));
    };
    var getEuropeanCountryOptions = function (countriesFilterData) {
        var _a, _b, _c;
        var transformedCountriesFilterDataOptions = function () {
            var _a, _b;
            return ((_b = (_a = countriesFilterData === null || countriesFilterData === void 0 ? void 0 : countriesFilterData.options) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                var _a;
                return (__assign(__assign({}, item), { label: (_a = item === null || item === void 0 ? void 0 : item.title) !== null && _a !== void 0 ? _a : '', value: "country-".concat(item === null || item === void 0 ? void 0 : item.id) }));
            })) !== null && _b !== void 0 ? _b : []);
        };
        var formCountryIdValues = (_c = (_b = (_a = form === null || form === void 0 ? void 0 : form.getState()) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.countryIds) === null || _c === void 0 ? void 0 : _c.map(function (item) { return item.value; });
        return __spreadArray(__spreadArray([], __read(transformedCountriesFilterDataOptions().filter(function (item) { var _a; return (_a = formCountryIdValues === null || formCountryIdValues === void 0 ? void 0 : formCountryIdValues.includes) === null || _a === void 0 ? void 0 : _a.call(formCountryIdValues, item === null || item === void 0 ? void 0 : item.value); })), false), __read(transformedCountriesFilterDataOptions().filter(function (item) { var _a; return !((_a = formCountryIdValues === null || formCountryIdValues === void 0 ? void 0 : formCountryIdValues.includes) === null || _a === void 0 ? void 0 : _a.call(formCountryIdValues, item === null || item === void 0 ? void 0 : item.value)); })), false);
    };
    var getUniversityOptions = function (universityAgreegationData) {
        var _a;
        return getSortedUniversityFilters(form, (_a = universityAgreegationData === null || universityAgreegationData === void 0 ? void 0 : universityAgreegationData.options) !== null && _a !== void 0 ? _a : []);
    };
    var getCountryOptions = function (stateAgreegationData) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var countryIds = (_d = ((_c = (_b = (_a = form.getState()) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.countryIds) !== null && _c !== void 0 ? _c : [])) === null || _d === void 0 ? void 0 : _d.map(function (op) { return op === null || op === void 0 ? void 0 : op.value; });
        return getFilterOptions(__spreadArray(__spreadArray([], __read((_f = ((_e = stateAgreegationData === null || stateAgreegationData === void 0 ? void 0 : stateAgreegationData.options) !== null && _e !== void 0 ? _e : [])) === null || _f === void 0 ? void 0 : _f.filter(function (op) { return countryIds === null || countryIds === void 0 ? void 0 : countryIds.includes(op === null || op === void 0 ? void 0 : op.id); })), false), __read((_h = ((_g = stateAgreegationData === null || stateAgreegationData === void 0 ? void 0 : stateAgreegationData.options) !== null && _g !== void 0 ? _g : [])) === null || _h === void 0 ? void 0 : _h.filter(function (op) { return !(countryIds === null || countryIds === void 0 ? void 0 : countryIds.includes(op === null || op === void 0 ? void 0 : op.id)); })), false));
    };
    var handleEligibiltyApply = function (eligibilityFormValues, updateEligibilityTab, eligibilityApplyCallback) { return __awaiter(void 0, void 0, void 0, function () {
        var eligibilityData, isReset;
        var _a;
        return __generator(this, function (_b) {
            eligibilityData = CfEligibilityUtil.getCfEligbilityPayload(eligibilityFormValues);
            form.batch(function () {
                Object.entries(eligibilityData).forEach(function (_a) {
                    var _b = __read(_a, 2), key = _b[0], value = _b[1];
                    form.change(key, value);
                });
            });
            isReset = Object.values(eligibilityData).every(isFalsy);
            if (isReset) {
                updateEligibilityTab === null || updateEligibilityTab === void 0 ? void 0 : updateEligibilityTab(null);
            }
            applyFilter === null || applyFilter === void 0 ? void 0 : applyFilter({
                values: (_a = form.getState()) === null || _a === void 0 ? void 0 : _a.values,
                isEligiblePayload: !isReset,
                scrollToTop: true
            });
            setInitialEligiblityValues === null || setInitialEligiblityValues === void 0 ? void 0 : setInitialEligiblityValues(eligibilityFormValues);
            eligibilityApplyCallback === null || eligibilityApplyCallback === void 0 ? void 0 : eligibilityApplyCallback(eligibilityData);
            return [2 /*return*/];
        });
    }); };
    var handleStudentSelect = function (examOptions, getOnboardingDataCallback, onBoardingDataUnsubscribeCallback, student, updateEligibilityTab, expandFilter, selectStudentRegion) { return __awaiter(void 0, void 0, void 0, function () {
        var eligibilityData, data, regionData, error_1, noElibilityDataFound;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    eligibilityData = {};
                    if (!student) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, CfEligibilityUtil.getCfEligibilityValuesForStudent(examOptions, student, getOnboardingDataCallback, onBoardingDataUnsubscribeCallback)];
                case 2:
                    data = _a.sent();
                    return [4 /*yield*/, (selectStudentRegion === null || selectStudentRegion === void 0 ? void 0 : selectStudentRegion(student))];
                case 3:
                    regionData = _a.sent();
                    // handleCardsAdditionLogic(data);
                    setInitialEligiblityValues === null || setInitialEligiblityValues === void 0 ? void 0 : setInitialEligiblityValues(__assign(__assign({}, data), (regionData !== null && regionData !== void 0 ? regionData : {})));
                    eligibilityData = __assign(__assign({}, data), (regionData !== null && regionData !== void 0 ? regionData : {}));
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console.log('Error in updating eligibility form using student', error_1);
                    return [3 /*break*/, 5];
                case 5:
                    noElibilityDataFound = Object.values(omit(eligibilityData, 'student')).every(isFalsy);
                    if (!student) {
                        setInitialEligiblityValues === null || setInitialEligiblityValues === void 0 ? void 0 : setInitialEligiblityValues(undefined);
                        handleEligibiltyApply(undefined, updateEligibilityTab);
                    }
                    else {
                        setTimeout(function () {
                            if (noElibilityDataFound) {
                                updateEligibilityTab === null || updateEligibilityTab === void 0 ? void 0 : updateEligibilityTab(null);
                                setInitialEligiblityValues === null || setInitialEligiblityValues === void 0 ? void 0 : setInitialEligiblityValues(undefined);
                            }
                            else {
                                eligibilitySchema.validate(eligibilityData).catch(function () { return expandFilter === null || expandFilter === void 0 ? void 0 : expandFilter(); });
                            }
                            handleEligibiltyApply(eligibilityData, updateEligibilityTab);
                        }, 0);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return {
        getDegreeOptions: getDegreeOptions,
        getIntakeOptions: getIntakeOptions,
        getCityOptions: getCityOptions,
        getStateOptions: getStateOptions,
        getEuropeanCountryOptions: getEuropeanCountryOptions,
        handleFilterApply: handleFilterApply,
        getUniversityOptions: getUniversityOptions,
        getCountryOptions: getCountryOptions,
        handleEligibiltyApply: handleEligibiltyApply,
        handleStudentSelect: handleStudentSelect,
        degreeValues: degreeValues,
        cityValues: cityValues,
        stateValues: stateValues,
        intakeValues: intakeValues,
        courseDurationValues: courseDurationValues,
        tuitionFeesValues: tuitionFeesValues,
        highOfferInstituteValue: highOfferInstituteValue,
        universitiesValues: universitiesValues,
        studentCurrencyValue: studentCurrencyValue,
        showOpenOnlyCourses: showOpenOnlyCourses,
        countryValues: countryValues,
        studentNationality: studentNationality
    };
};
export default useCFFilters;
//# sourceMappingURL=useCFFilters.js.map